function a(a,i,e,n){a._m(i),a.o(i,"ApplicationTemplate",()=>a.f(o));var o=a.i(e("08d3ead7"));}